import { useEffect } from 'react';

export const GOOGLE_ADS_ID = 'AW-862443742';
export const ENQUIRY_CONVERSION_LABEL = 'AW-862443742/dv9-CKadlP8cEN6xn5sD';
const SCRIPT_ID = 'google-ads-gtag';
const fired = new Set();

function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
  }
  return window.gtag;
}

export function loadGoogleAdsTag() {
  if (typeof window === 'undefined' || document.getElementById(SCRIPT_ID)) return;
  const gtag = ensureGtag();
  const s = document.createElement('script');
  s.id = SCRIPT_ID;
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(s);
  gtag('js', new Date());
  gtag('config', GOOGLE_ADS_ID);
}

export function useGoogleAdsTag() {
  useEffect(() => { loadGoogleAdsTag(); }, []);
}

// Fires once per saved enquiry ref; safe against double-clicks, retries and re-renders.
export function fireEnquiryConversion(ref) {
  if (!ref || fired.has(ref)) return false;
  fired.add(ref);
  ensureGtag()('event', 'conversion', { send_to: ENQUIRY_CONVERSION_LABEL, value: 1.0, currency: 'GBP', transaction_id: String(ref) });
  return true;
}
